import { Aufgabe, AufgabeStatus } from "../../../api";
import { DEFAULT_LANGUAGE } from "../../../config/language";
import { DEFAULT_EMPATHY } from "../../../config";
import type { AufgabeFormValues } from "../../../types/aufgabenTypes";

/** Fallback Scheduler for Aufgaben that don't explicitly pick one (system-provided GLOBAL default). */
export const DEFAULT_SCHEDULER_ID = "schedulerdefaultglob1";

type Params = {
  aufgabe?: Partial<Aufgabe> | null;
  defaultPrompt?: string;
  phoneNormalizer?: (input: string | null | undefined) => string;
};

export function buildInitialAufgabeFormValues({
  aufgabe,
  defaultPrompt,
  phoneNormalizer,
}: Params): AufgabeFormValues {
  const normalizePhone = phoneNormalizer ?? (() => "");

  return {
    titel: aufgabe?.titel ?? "",
    beschreibung: aufgabe?.beschreibung ?? "",
    sprache: aufgabe?.sprache ?? DEFAULT_LANGUAGE,
    prompt: aufgabe?.prompt ?? defaultPrompt ?? "",
    foreignPrompt: aufgabe?.foreignPrompt ?? "",
    stimmeId: aufgabe?.stimmeId ?? "",
    telefonnummer: aufgabe ? normalizePhone(aufgabe.telefonnummer ?? "") : "",
    empathie: aufgabe?.empathie ?? DEFAULT_EMPATHY,
    mandantId: aufgabe?.mandantId ?? "",
    schedulerId: aufgabe?.schedulerId ?? DEFAULT_SCHEDULER_ID,
    status: (aufgabe?.status as AufgabeStatus) ?? "PAUSIERT",
    inboundConfigDurationInHours:
      (aufgabe as any)?.inbound_config_duration_in_hours ?? undefined,
    inboundMode: (aufgabe as any)?.inbound_mode ?? "NIE",
    updateInboundConfigTimeOnUpdate: (aufgabe as any)?.update_inbound_config_time_on_update ?? false,
    useInboundPrompt: (aufgabe as any)?.use_inbound_prompt ?? false,
    useSeparateToolsForInbound: (aufgabe as any)?.use_separate_tools_for_inbound ?? false,
    anzahlAnrufversucheMax:
      (aufgabe as any)?.anzahl_anrufversuche_max ?? undefined,
    auftragssystemAuftragId: aufgabe?.auftragssystem_auftrag_id ?? "",
    speechModel: aufgabe?.speechModel ?? "",
    toolIds: [...(aufgabe?.toolIds ?? [])].sort(),
  };
}
